import { useMemo } from 'react'
import { fileHelpers, fileNameFromUrl, FileOption } from '../../../../../features/files'
import { useDataTypesHooks } from '../../../../../features/data-types'
import { toDate } from '../../../../../utils/typeUtils'
import { Delivery, DeliveryMethod, DeliveryOrder } from '../../../state/types'
import { deliveryHelpers } from '../../../hooks/deliveryHooks'
import { DeliveryNotePDF } from '../delivery-note-pdf/deliveryNotePDF'

type Props = {
    deliveries: Delivery[]
    deliveryOrders: DeliveryOrder[]
}

export const DeliveryNotesFileOptions = (props: Props) => {
    const { deliveries, deliveryOrders } = props

    const { deliveryNoteFileName2 } = fileHelpers
    const { describeDelivery } = deliveryHelpers
    const { formatDate } = useDataTypesHooks()

    const findDeliveryOrder = (delivery: Delivery) => deliveryOrders.find(order => order.id === delivery.orderId)

    const fileOptions = useMemo(() => {
        const options: FileOption[] = []

        // A cancelled delivery note isn't offered: downloading it could pass for a valid delivery
        deliveries.filter(delivery => !delivery.cancelled).forEach(delivery => {
            const { method, deliveryNoteUrl} = delivery
            if (method !== DeliveryMethod.RECEPTION || deliveryNoteUrl) {
                const deliveryOrder = findDeliveryOrder(delivery)
                const label = `${describeDelivery(delivery, deliveryOrder, true)} - ${formatDate(toDate(delivery.date))}`
                const pdfId = `delivery-${delivery.id}-pdf`
                const name = deliveryNoteUrl ? fileNameFromUrl(deliveryNoteUrl)! : deliveryNoteFileName2(delivery, deliveryOrder)
                options.push({
                    id: pdfId,
                    label,
                    fileName: name,
                    group: method === DeliveryMethod.RETURN ? 'Notas de Devolución' : 'Remitos',
                    ...(deliveryNoteUrl ? {
                        url: deliveryNoteUrl
                    } : {
                        pdf: {
                            id: pdfId,
                            component: <DeliveryNotePDF
                                id={pdfId}
                                delivery={delivery}
                                deliveryOrder={deliveryOrder}
                            />
                        }
                    })
                })
            }
        })

        return options
    }, [deliveries, deliveryOrders])

    return fileOptions
}
